import React from 'react';
import { useSelector } from 'react-redux';
import { getPickPolicies } from 'src/slices/pickPolicies';
import FormSelect from 'shared/forms/FormSelect';

const PickPolicyDropdown = (props) => {

    const pickPolicies = useSelector(getPickPolicies);

    return (

        <FormSelect
            data={pickPolicies}
            textField="description"
            dataItemKey="value"
            {...props}
        />
    );
};

export default PickPolicyDropdown;